export const CAL_ASSAY_SUMMARY_DATA_FETCHING = 'CAL_ASSAY_SUMMARY_DATA_FETCHING';
export const CAL_ASSAY_SUMMARY_DATA_FETCHED = 'CAL_ASSAY_SUMMARY_DATA_FETCHED';
export const CAL_ASSAY_SUMMARY_DATA_FETCHING_FAILED = 'CAL_ASSAY_SUMMARY_DATA_FETCHING_FAILED';
export const CAL_ASSAY_STATE_ADD="CAL_ASSAY_STATE_ADD";
export const CAL_ASSAY_STATE_REMOVE="CAL_ASSAY_STATE_REMOVE";

export const TEST_FIELD = "testName";
export const IS_PASSED_FIELD = "isPassed";
export const LOT_EXP_DATE = "calibrationExpirationDate";
export const CAL_ERROR_API_ERROR = "Error occurred while getting Calibration Assay Summary";
export const ACCESS2 = "ACCESS2";
export const DXI = "DXI";